<!-- 分享图片 -->
<template>
    <div class="shareDynamic">

        <div v-if="isWeChat">
            <browser-open></browser-open>
        </div>

        <div v-else>
            <top-nav :appLink="params.appLink"></top-nav>
        <!-- 头像块 -->
        <div class="avatar">
            <div>
                <van-image round width="33" height="33" :src="dynamicData.dynamicUserHeadPortrait" />
            </div>

            <div class="n-left">
                <span class="name">{{ dynamicData.dynamicUserName }}</span>
            </div>

            <!-- <div class="n-right">
                <van-button class="btn" round size="small" type="default">已关注</van-button>
            </div> -->
        </div>

        <!-- 图片 -->

        <div class="image" v-if="params.type == SHARETYPE.IMAGE">
            <image-view :images="images"></image-view>
        </div>

        <div class="image" v-if="params.type == SHARETYPE.VIDEO">
            <video-view :videoUrl="dynamicData.attachFile" :cover="dynamicData.cover"></video-view>
        </div>

        <!-- 文案 -->

        <div class="copywriting">

            <div class="text">
                {{ dynamicData.content }}
            </div>

            <van-tag style="font-size:11px;" round size="large" color="#CFCFCF">
                <img style="margin-right:3px" width="14" src="/imgs/htbg.png" />
                <span style="color: #292929;">{{ dynamicData.talkName }}</span>
            </van-tag>

            <div class="time-location">{{ dynamicData.beforeTime }} · {{ dynamicData.location }} </div>

            <van-divider />

            <div class="user-bottom">
                <div>
                    <div class="block-lf">赞过 {{ dynamicData.likeNum }}</div>
                    <div class="block-rg">点赞列表 ></div>
                </div>

                <div class="u-avatar">
                    <van-image class="img" v-for="(v, i ) in commentData" :key="i" round width="27" height="27"
                        :src="v.userHeadPortrait" />
                </div>
            </div>
        </div>
        </div>

    </div>
</template>

<script>
import topNav from '../../components/topNav.vue';
import { getUrlParam ,isWeChatBrowser} from '../../config/utils'
import { getShareData, getCommentListH5 } from "../../api/sy";
import ImageView from '../../components/imageView.vue';
import VideoView from '../../components/videoView.vue';
import BrowserOpen from './browserOpen.vue';

const SHARETYPE = {
    IMAGE: 0,
    VIDEO: 1,
    TEXT: 2
}

export default {
    components: { topNav, ImageView,VideoView, BrowserOpen },
    data() {
        return {
            isWeChat: isWeChatBrowser(),
            SHARETYPE: {
                IMAGE: 0,
                VIDEO: 1,
                TEXT: 2
            },
            images: [],
            params: {
                id: '',
                type: '',
                appLink: ''
            },
            dynamicData: {},
            commentData: {}
        };
    },
    mounted() {
        this.handleUrl()
    },
    methods: {
        handleUrl() {
            if(!this.$route.query.appLink) return;
            this.params.appLink = this.$Base64.decode(this.$route.query.appLink);
            this.params.id = getUrlParam(this.params.appLink, 'dynamicId');
            this.params.type = getUrlParam(this.params.appLink, 'type')
            this.handleGetData();
            this.handleGetCommentListH5();
        },

        handleGetData() {
            let params = {
                dynamicId: this.params.id
            }
            getShareData(params).then(res => {
                if (res.data.code == 200) {
                    this.dynamicData = res.data.data;
                    this.images = this.dynamicData.attachFile.split(',')
                }
            }).catch(err => {
                console.log(err)
            })

        },
        handleGetCommentListH5() {
            let params = {
                dynamicId: this.params.id,
                pageSize: 9
            }
            getCommentListH5(params).then(res => {
                if (res.data.code == 200) {
                    this.commentData = res.data.data.list;
                }
            }).catch(err => {
                console.log(err)
            })

        },
    }
}
</script>

<style lang="less" scoped>
.shareDynamic {


    .avatar {
        height: 55px;
        display: flex;
        padding: 11px 14px 11px 14px;
        background: #FFFFFF;

        .n-left {
            margin-left: 10px;

            .name {
                color: #292929;
                font-size: 13px;
                font-weight: bold;
                line-height: 30px;
            }
        }

        .n-right {
            flex: 1;
            text-align: right;
            font-size: 12px;
            margin-top: 4px;

            .btn {
                height: 25px;
            }
        }

    }

    .image {
        // height: 427px;
        background: rgb(206, 225, 247);
    }

    .copywriting {
        background: #FFFFFF;
        height: auto;
        min-height: 200px;
        padding: 17px 23px 17px 23px;

        .text {
            font-size: 13px;
            font-weight: bold;
            margin-bottom: 16px;
            line-height: 25px;
        }

        .time-location {
            margin-top: 13px;
            font-size: 10px;
            color: #A7A7A7;
            line-height: 25px;
        }

        .user-bottom {
            color: #373737;
            font-weight: 500;
            font-size: 11px;

            .block-lf {
                display: inline-block;
            }

            .block-rg {
                display: inline-block;
                float: right;
            }

            .u-avatar {
                margin-top: 11px;

                .img {
                    margin-right: 8.5px;
                }
            }
        }

    }

}
</style>>
